/**
 * Expressão regular para tratamento de dominios
 * abaxo estamos convertendo 
 */
const expresaoRegular = /http:\/\/|https:\/\/|www.|\//gi

export const tratamentoDeDominios = (dominio) => {
    const novoDominio = dominio.replace(expresaoRegular, "");
    return novoDominio;
}

export const validarDominios = (dominio) => {
    const dominiosInvalidos = ["www.", "https", "http", "/", "//", ]
    const validar = dominiosInvalidos.indexOf(dominio)
    if(validar !== -1){
        return false;
    }
    return true;
}

/**Validar senhas */
export const senhasInvalidas = (senha) => {
    const listaDeSenhas = {
        validarSenha: [
            "123456", "password", "123456789", 
            "12345678", "1234567890", "12345", "111111",
            "1234567", "sunshine", "qwerty", "iloveyou", 
            "princess", "welcome", "666666", 
            "abc123", "football", "123123", "monkey",
            "654321", "!@#$%^&*", "charlie", "aa123456",
            "donald", "password1", "qwerty123"
        ]
    };

    const validarSenha = listaDeSenhas.validarSenha.indexOf(senha)
    if(validarSenha !== -1){
        return false
    }
    return true;
    
}

